var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("UIButton", {
    class: _vm.customHeading,
    attrs: {
      processing: _vm.processing,
      variant: _vm.buttonVariant,
      size: _vm.buttonSize,
      fullWidth: _vm.fullWidth,
      buttonText: "Withdraw request",
      buttonClasses: "customButtonCard",
    },
    on: { click: _vm.revokeRequest },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }